import { inject, Injectable } from '@angular/core';
import { MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';

import { format, isValid, parse } from 'date-fns';

import { DATE_FORMATS } from '../utilities/date.utils';

export interface MaterialDateFormats {
  parse: { dateInput: string };
  display: {
    dateInput: string;
    monthYearLabel: string;
    dateA11yLabel: string;
    monthYearA11yLabel: string;
  };
}

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  private readonly _dateFormats = inject(MAT_DATE_FORMATS, {
    optional: true,
  }) as MaterialDateFormats | null;

  override parse(value: string): Date | null {
    if (!value) {
      return null;
    }

    const parseFormat = this._dateFormats?.parse?.dateInput ?? DATE_FORMATS.display;
    const parsedDate = parse(value, parseFormat, new Date());

    if (isValid(parsedDate)) {
      return parsedDate;
    }

    const nativeDate = super.parse(value);
    return nativeDate && isValid(nativeDate) ? nativeDate : null;
  }

  override format(date: Date, displayFormat: string): string {
    if (!isValid(date)) {
      return '';
    }
    return format(date, displayFormat);
  }
}
